import NoisePermitForm from '@/components/public/services/noise-permit/NoisePermitForm';
import ServiceRequestLayout from '@/components/public/services/ServiceRequestLayout';

export default function NoisePermit() {
  return (
    <ServiceRequestLayout
      seoTitle="Licença especial de ruído"
      seoDescription="Submeta um pedido relativo a atividades ruidosas temporárias ou excecionais, sujeito a apreciação nos termos legais."
      badge="Serviços ao Cidadão"
      breadcrumbs={[
        { label: 'Serviços', href: '/services' },
        { label: 'Licença especial de ruído' },
      ]}
      title="Licença especial de ruído."
      accentWord="Ruído."
      subtitle="Submeta um pedido relativo a atividades ruidosas temporárias ou excecionais, sujeito a apreciação nos termos legais."
      panelTitle="Pedido de licença especial de ruído"
      panelIntro="O pedido deve ser apresentado com a antecedência legalmente exigida, em regra 15 dias úteis antes da atividade, ficando sujeito a apreciação pela entidade competente."
    >
      <NoisePermitForm />
    </ServiceRequestLayout>
  );
}
